<template>
  <v-app>
<!--    nav drawer-->
<!--    <v-navigation-drawer-->
<!--        app-->
<!--        v-if="user"-->
<!--        v-model="drawer"-->
<!--    >-->
<!--      <v-list dense v-for="item in drawerItems"  :key="item.icon">-->
<!--        &lt;!&ndash;link to admin panel&ndash;&gt;-->
<!--        <v-list-item @click="route(item)" link>-->
<!--          <v-list-item-action>-->
<!--            <v-icon>{{item.icon}}</v-icon>-->
<!--          </v-list-item-action>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>{{item.title}}</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->
<!--      </v-list>-->
<!--    </v-navigation-drawer>-->
    <!--    app bar-->
    <v-app-bar absolute flat app v-if="listingData">
      <v-toolbar-title>
        <router-link :to="'/' + listingData.publicListingId + '/' + listingData.listingId">
          <v-img
              v-if="listingData.toolbarLogo"
              :src="listingData.toolbarLogo.url"
              class="shrink mt-2 mb-5 mt-2"
              contain
              min-width="180"
              width="150"
          />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <my-list-button v-if="user"></my-list-button>
    </v-app-bar>
<!--    main router view-->
      <v-main fluid>
          <router-view/>
      </v-main>
    <div style="height: 350px"></div>

    <!--footer component-->
    <v-footer padless
              dark
              height="auto"
              app
              absolute
              inset
              style="margin-bottom: 0 !important;background-color: #2D2D2D;">
      <v-container class="grey darken-4" fluid>
        <v-layout row align-center justify-center>
          <v-flex
              xs12 sm12 md6 lg6
              v-if="listingData"
              class="flex transparent">
              <v-card class="elevation-0 mb-12 pb-6 transparent">
                <v-card-title>
                  <v-img
                      v-if="listingData.toolbarLogo"
                      :src="listingData.toolbarLogo.url"
                      class="shrink"
                      contain
                      min-width="180"
                      width="150"
                  />
                </v-card-title>
                <v-row
                    no-gutters
                    style="flex-wrap: nowrap;"
                >
<!--                  phone number-->
                  <v-col
                      cols="6"
                      class="flex-grow-0 flex-shrink-0"
                  >
                    <v-card
                        class="pa-2 transparent"
                        outlined
                        tile
                    >
                      <div class="ml-4">
                        <v-icon class="white--text">phone_iphone</v-icon>
                        <strong class="subtitle-1 white--text" >
                          {{formatPhoneNumber(listingData.listingContactNumber)}}
                        </strong>
                      </div>
                      <div class="ml-4 subtitle-1 white--text">
                        {{listingData.note}}
                      </div>
                    </v-card>
                  </v-col>
                  <v-col
                      cols="3"
                      class="flex-grow-0 flex-shrink-0"
                  >
                  </v-col>
<!--                  social logos-->
                  <v-col
                      cols="3"
                      class="flex-grow-0 flex-shrink-0"
                  >
                    <v-card
                        class="pa-2 transparent d-flex  flex-column"
                        outlined
                        tile
                    >
                      <v-btn
                          v-for="(icon, index)  in listingData.socialIcons"
                          :key="index"
                          dark
                          icon
                          @click="routeToSocial(icon.url)"
                      >
                        <v-icon>
                          {{ icon.icon }}
                        </v-icon>
                        {{icon.tag}}
                      </v-btn>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
          </v-flex>
        </v-layout>
        <!--                listing name-->
        <v-card-text v-if="listingData" class="py-2  text-center white--text ">
          <v-divider></v-divider>
          <strong>{{listingData.listingName}}</strong> — ⓒ{{ new Date().getFullYear() }}
        </v-card-text>
      </v-container>
    </v-footer>
  </v-app>
</template>
<script>


export default {
  data: () => ({
    drawer: false,
    socialIcons: [
      {icon: 'mdi-facebook', tag: 'facebook', url: 'https://www.facebook.com'},
      {icon: 'mdi-twitter', tag: 'twitter', url: ''},
      {icon: 'mdi-linkedin', tag: 'linkedin', url: ''},
      {icon: 'mdi-instagram', tag: 'instagram', url: ''}
    ],
    drawerItems: [
      // {title: 'Dashboard', route: '/', icon: 'mdi-view-dashboard-outline', type: 'link'},
      // {title: 'Manage Numbers', route: '/getNewPhoneNumber', icon: 'mdi-phone-plus', type: 'link'},
      // {title: 'Profile settings', route: '/editProfile', icon: 'mdi-account', type: 'link'},
      // {title: 'Log out', route: '', icon: 'mdi-exit-to-app', type: 'method', method: 'signUserOut'},
    ]
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
    listingData () {
      let listingData = this.$store.getters.listingData
      // console.log(listingData)
      return listingData
    }
  },
  // created () {
  //   let db = this.$store.state.db
  //   let userRef = doc(db, 'anonUsers', payload.uid)
  // },
  methods: {
    formatPhoneNumber(phoneNumberString) {
      // console.log(phoneNumberString)
      let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
      let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        // let intlCode = (match[1] ? '+1 ' : '');
        return ['(', match[2], ') ', match[3], '-', match[4]].join('');
      }
      return null;
    },
    route (drawerItem) {
      if (drawerItem.type !== 'method') {
        this.$router.push(drawerItem.route)
      } else {
        if (drawerItem.method === 'signUserOut') {
          this.signUserOut()
        }
      }
    },
    routeToSocial (url) {
      window.open( url)
      // window.location.href = url
    }
  }
}
</script>

